/** Base p?blica dos arquivos servidos pelo Oikos (mesmo padr?o de FaturamentoDashboard). */
export const OIKOS_FILES_BASE = 'https://oikos.ecoss.is/oikos/'

/** XML da NF ? anexo vinculado ? entidade `nf` (FaturamentoDashboard). */
export const TP_DOC_NF_XML = 39

/** PDF DANFE ? anexo vinculado ? entidade `nf` (FaturamentoDashboard). */
export const TP_DOC_NF_DANFE = 40

/**
 * PDF de libera??o para faturamento ? vinculado ao `rec` via documentoVinc (tabRef `rec`, tabId rec_id).
 * Deve existir em `tpDocumento` com o mesmo id; ajuste se o cadastro no BD for outro.
 */
export const TP_DOC_REC_LIBERACAO_FATURAMENTO = 41

/** Pedido de emiss?o NFS-e na Kamino (PHP Oikos). */
export const KAMINO_EMIT_NFSE_URL = `${OIKOS_FILES_BASE}_kamino_emitNFSE.php`

/** Sync de NFS-e emitidas na Kamino ? nf/xml/pdf no Oikos. */
export const KAMINO_CHECK_NFSE_URL = `${OIKOS_FILES_BASE}_kamino_checkNFSE.php`

/** Quem pode editar dados da NF e enviar pedido de emiss?o. */
export const KAMINO_EMIT_PF_IDS = [1, 2, 3, 31]

/** Tipo gen?rico j? existente ? anexo avulso do projeto no processo de faturamento. */
export const TP_DOC_OUTROS = 18

/** Documenta??o de suporte do faturamento (tpDocumento 84?93). */
export const TP_DOC_CND_FEDERAL = 84
export const TP_DOC_CND_ESTADUAL = 85
export const TP_DOC_CND_MUNICIPAL = 86
export const TP_DOC_GUIA_FGTS = 87
export const TP_DOC_GUIA_INSS = 88
export const TP_DOC_GUIA_ISS = 89
export const TP_DOC_COMPROVANTE_FGTS = 90
export const TP_DOC_COMPROVANTE_INSS = 91
export const TP_DOC_COMPROVANTE_ISS = 92
export const TP_DOC_FOLHA_PAGAMENTO = 93

export const FAT_SUPPORT_DOC_TYPES = [
  { id: TP_DOC_CND_FEDERAL, label: 'CND Federal' },
  { id: TP_DOC_CND_ESTADUAL, label: 'CND Estadual' },
  { id: TP_DOC_CND_MUNICIPAL, label: 'CND Municipal' },
  { id: TP_DOC_GUIA_FGTS, label: 'Guia FGTS' },
  { id: TP_DOC_GUIA_INSS, label: 'Guia INSS' },
  { id: TP_DOC_GUIA_ISS, label: 'Guia ISS' },
  { id: TP_DOC_COMPROVANTE_FGTS, label: 'Comprovante FGTS' },
  { id: TP_DOC_COMPROVANTE_INSS, label: 'Comprovante INSS' },
  { id: TP_DOC_COMPROVANTE_ISS, label: 'Comprovante ISS' },
  { id: TP_DOC_FOLHA_PAGAMENTO, label: 'Folha de pagamento' },
  { id: TP_DOC_OUTROS, label: 'Outros' },
]

export const FAT_SUPPORT_DOC_TYPE_IDS = FAT_SUPPORT_DOC_TYPES.map((t) => t.id)

/** Os 10 tipos exigidos no e-mail da NFS-e (sem o gen?rico Outros). */
export const FAT_SUPPORT_REQUIRED_TYPES = FAT_SUPPORT_DOC_TYPES.filter((t) => t.id !== TP_DOC_OUTROS)

export const ECOSSIS_PJ_IDS = [1, 2]

